// Kiểm tra object hoặc array rỗng
export const isEmpty = (obj: unknown): boolean => {
  return (
    [Object, Array].includes((obj as any)?.constructor) &&
    !Object.entries((obj as any) || {}).length
  );
};

// Flatten object thành object 1 tầng
export const flattenObj = (ob: Record<string, any>): Record<string, any> => {
  const result: Record<string, any> = {};

  for (const key in ob) {
    if (
      typeof ob[key] === "object" &&
      ob[key] !== null &&
      !Array.isArray(ob[key])
    ) {
      const temp = flattenObj(ob[key]);
      for (const nestedKey in temp) {
        result[`${key}.${nestedKey}`] = temp[nestedKey];
      }
    } else {
      result[key] = ob[key];
    }
  }

  return result;
};

// Loại bỏ các object trùng nhau trong mảng theo key
export const uniqify = <T extends Record<string, any>>(
  array: T[] | undefined,
  key: keyof T
): T[] => {
  if (!array || array.length === 0 || !key) return [];

  return array.reduce<T[]>((prev, curr) => {
    return prev.find((a) => a[key] === curr[key]) ? prev : [...prev, curr];
  }, []);
};
